import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';

export const useOpenConnectWalletModal = () => {
    const dispatch = useDispatch();
    return useCallback(() => {
        dispatch(
            showModalAction({
                modalName: ModalName.CONNECT_WALLET_MODAL,
                modalTitle: 'Connect Wallet',
            }),
        );
    }, [dispatch]);
};
